const envApiBase = process.env.REACT_APP_API_BASE_URL?.replace(/\/+$/, '');

function isLoopback(hostname: string): boolean {
  return hostname === 'localhost' || hostname === '127.0.0.1' || hostname === '::1' || hostname === '[::1]';
}

// Relative /api uses the dev server proxy (see package.json "proxy").
// Calling 127.0.0.1 from a localhost page is a different site, so the browser
// drops the admin session cookie and authenticated checks return 401.
function resolveApiBase(): string {
  if (!envApiBase) return '/api';
  if (typeof window === 'undefined') return `${envApiBase}/api`;
  try {
    const api = new URL(envApiBase, window.location.href);
    if (isLoopback(window.location.hostname) && isLoopback(api.hostname) && api.host !== window.location.host) {
      return '/api';
    }
  } catch {
    return `${envApiBase}/api`;
  }
  return `${envApiBase}/api`;
}

export const API_BASE_URL = resolveApiBase();
